import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { User } from "../../interfaces/models/user";
import { StateExtended } from "../../interfaces/StateExtended";

export function useAppUserDetailsSelector() {
    const user: any = useSelector((state: StateExtended) => state.user.user);

    return user;
}

export function useAppUserAuthSelector() {
    const isAuth: boolean = useSelector((state: StateExtended) => state.user.isAuthenticated);

    return isAuth;
}

export function useAppUserTokenSelector() {
    const token: string | null = useSelector((state: StateExtended) => state.user.token);

    return token;
}

export function useAppUserPermissionsSelector() {
    const permissions: any[] | null = useSelector((state: StateExtended) => state.user.permissions?.permissions || null);

    return permissions;
}

export function useAppUserDataSelector() {
    const userData: any = useSelector((state: StateExtended) => state.user.userData);

    return userData;
}

// export function useAppUserSubscriptionPlanSelector() {
//     const subscriptionPlan: any | null = useSelector((state: StateExtended) => state.user.subscriptionPlan || null);

//     return subscriptionPlan;
// }
